var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Изюм")]),_c('ServiceStatus'),_c('a',{attrs:{"href":"http://servicemonitoringizum.ru:3000/"}},[_vm._v("grafana")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }